import { ReactNode } from 'react';

import useCache from './useCache';

export interface CacheProps {
  children: ReactNode;
  cacheKey: string;
  disabled?: boolean;
}

const Cache: React.FunctionComponent<CacheProps> = function ({
  children,
  cacheKey,
  disabled = false,
}) {
  useCache(cacheKey, disabled);
  return <>{children}</>;
};

export default Cache;
